// extracted by mini-css-extract-plugin
module.exports = {"label-text":"CountrySelect_label-text__UJTn6","country-select-with":"CountrySelect_country-select-with__Y2AFM"};